<template>
  <router-view :key="key"></router-view>
</template>

<script>
  export default {
    name:'App',
    computed:{
      key(){
        // console.log(this.$route);
        return this.$route.fullPath?this.$route.fullPath:this.$route.fullPath+new Date()
      }
    }
  }
</script>
<style lang="scss" scoped>

</style>